<template>
  <v-card class="h-100 page-border">
    <div v-if="!isLoading">
      <div v-if="!hideHeading" class="page-top px-3 py-2" :class="[{'py-2': titleHasPaddingY}]">
        <div class="page-title">
          <slot name="title"/>
        </div>
        <div class="page-action">
          <slot name="actions"/>
        </div>
      </div>

      <slot/>
    </div>
    <div class="preload-box h-100 pa-2" v-else>
      <v-progress-circular indeterminate :size="50" color="primary"></v-progress-circular>
    </div>
  </v-card>
</template>
<script>
export default  {
  props: {
    isLoading: {
      type: Boolean,
      default:false
    },
    hideWrapper: {
      type: Boolean,
      default: false
    },
    titleHasPaddingY:{
      type: Boolean,
      default:true
    },
    hideHeading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.page-border {
  border: 1px solid #D9D9D9;
  border-radius: 8px;
  overflow: hidden;
}
.page-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.page-title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  color: #8AA1AC;
  text-transform: uppercase;
  display: flex;
  align-items: center;
}
.page-action {
  display: flex;
  gap: 0.4rem;

  & button {
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    & button {
      margin: 0;
      &:not(.v-btn--icon) {
        flex-grow: 1;
      }
    }
  }
}
</style>
